

import React, { useState, useEffect, useRef,useContext } from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import $, { fn, nodeName } from 'jquery';
import { Link, redirect } from "react-router-dom";
import "../App.css";
import Header from "./Header.js"
import { Table, Rate } from "rsuite";
import {Form,Row,Col,Button,Modal} from "react-bootstrap"
import CommonComponents from "./CommonComponents.js";
import MakePayment from "./MakePayment";
import {formatDateText} from "./CommonFunctions.js"
import { DataGrid } from "@mui/x-data-grid";
import { Box, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { NumericFormat } from "react-number-format";
import set from "date-fns/esm/set/index";
const { Column, HeaderCell, Cell } = Table;
const url=process.env.REACT_APP_SERVER_URL;

export const TenantHistory = () => {
    const [tenancyDetails, setTenancyDetails] = useState([]);
    const [sortColumn, setSortColumn] = useState();
    const [sortType, setSortType] = useState();
    const [loading, setLoading] = useState(false);
    const {displayNotificationMessage}=useContext(CommonComponents);
    const [allRooms,setAllRooms]=useState([]);
    const [roomNumber,setRoomNumber]=useState("");
    const [isPayment,setIsPayment] = useState(false);
    const [tenancyId,setTenancyId] = useState("");
    const [showVoidTenancy,setShowVoidTenancy]=useState(false);
    const [selectedRowData,setSelectedRowData]=useState({});
    const navigate=useNavigate();
   
    useEffect(() => {
      getAllRooms();
        getAllTenantsHistory(null);
     
   }, []);
   const propsForMakePayment={
    tenancyId
   }


   const getData = () => {
    if (sortColumn && sortType) {
      return tenancyDetails.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
      
        console.log(typeof x)
        if (typeof x === 'string') {
          x = x.charCodeAt();
          console.log(typeof x + ' x: ' +x)
        }
        if (typeof y === 'string') {
          y = y.charCodeAt();
          console.log(typeof y + ' y: ' +y)
        }
        if (sortType === 'asc') {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return tenancyDetails;
  }
  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };


  const getAllRooms=async()=>{
    try{
      await axios.get(`${url}/rooms`).then((responseForAllRooms)=>{
        console.log(responseForAllRooms.data);
        setAllRooms(responseForAllRooms.data);
      })

    }
    catch(error){
      console.log(error);
    }
   }



  const getAllTenantsHistory= async(roomNumber) =>{
    try{
      if(roomNumber){
        await axios.get(`${url}/tenantHistory/${roomNumber}`).then((responseForTenantHistory)=>{
            console.log(responseForTenantHistory.data);
            setTenancyDetails(responseForTenantHistory.data);

        })
      }
      else{
        await axios.get(`${url}/tenantHistory`).then((responseForTenantHistory)=>{
          console.log(responseForTenantHistory.data);
          setTenancyDetails(responseForTenantHistory.data);

      })

      }

    } catch(error){
        console.log(error);
    }
  }
  const updatePrevTenancyIdInVacancyTracking = async(tenancyId) =>{
    try{
      await axios.patch(`${url}/vacancyTracking/updatePrevTenancyId/${tenancyId}`,{}).then((responseForUpdating)=>{
        console.log(responseForUpdating.data)
      })

    }
    catch(error){
      console.log(error);
    }
  }
  const updateNextTenancyIdInVacancyTracking = async(tenancyId) =>{
    try{
      await axios.patch(`${url}/vacancyTracking/updateNextTenancyId/${tenancyId}`,{}).then((responseForUpdating)=>{
        console.log(responseForUpdating.data)
      })

    }
    catch(error){
      console.log(error);
    }
  } 
  const deleteTenancyById = async(tenancyId,roomId) =>{
    try{
        var deleteSuccessFully=false;
        await axios.delete(`${url}/tenant_customer/${tenancyId}`).then ((responseForDeletingRelation)=>{
            deleteSuccessFully=true;
        })
        await axios.delete(`${url}/tenants/${tenancyId}`).then((responseForDeleteTenancy) => {
            console.log(responseForDeleteTenancy.data);
            updatePrevTenancyIdInVacancyTracking(tenancyId);
            updateNextTenancyIdInVacancyTracking(tenancyId);
            getAllTenantsHistory(roomNumber);
            displayNotificationMessage("success", " Deleted Guest Information for room : " + roomId + " ( tenancyId: " + tenancyId + " )");
        })
        
        


    }
    catch(error){
        console.log(error);
    }
  }
  
  const columns=[
      { field: `roomid`, headerName: 'Room Number', width: 100, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
        
          return <a onClick={(e)=>{
            // setValueTenancyId(row.id);
            navigate(`/tenants/add/${currentRow.id}`, { state:{ tenancyId: currentRow.id} })}}>
          <Link>
            {currentRow.roomid}
          </Link>
          </a>
      } },
      { field: 'id', headerName: 'Tenancy Id', width: 100, align: 'left' },
      { field: 'names', headerName: 'Guest Names', width: 150, align: 'left' },
      { field: 'phoneNumbers', headerName: 'Phone Numbers', width: 150, align: 'left' },
      { field: 'checkin', headerName: 'Checkin', width: 150, align: 'left' ,
        renderCell:(params)=>{
          const currentRow=params.row;
          return formatDateText(currentRow.checkin) 
      } },
      { field: 'checkout', headerName: 'Expected Checkout', width: 150, align: 'left' ,
        renderCell:(params)=>{
          const currentRow=params.row;
          return formatDateText(currentRow.checkout) 
      } },
      { field: 'actualCheckoutDate', headerName: 'Actual Checkout', width: 150, align: 'left',
        renderCell:(params)=>{
          const currentRow=params.row;
          return formatDateText(currentRow.actualCheckoutDate) 
      } },
      { field: 'status', headerName: 'Status', width: 150, align: 'left' },
      { field: 'rate', headerName: 'Rate', width: 120, align: 'left',
        renderCell:(params)=>{
          const currentRow=params.row;
          return <NumericFormat value={currentRow.rate} thousandSeparator prefix={'$'} displayType="text"/>;
    
          
         }
       },
      { field: 'rentalType', headerName: 'Rental Type', width: 120, align: 'left' },
      {field: 'actions', headerName: 'Actions', width: 120, align: 'left',
        renderCell:(params)=>{
          const currentRow=params.row;
          return <>
          {/* <Link >Edit</Link> <br></br> */}
          <Link onClick={(e)=>{
            setShowVoidTenancy(true);
            setTenancyId(currentRow.id);
            setRoomNumber(currentRow.roomid);
            setSelectedRowData(currentRow);
          }}>Void</Link><br></br>
                {/* <Link onMouseMove={()=>setIsPayment(false)} 
                onTouchMove={()=>setIsPayment(false)}
                      onClick={() =>{setIsPayment(true);setTenancyId(currentRow.id)}}>Payment</Link> */}
          </>
    
          
         }

      }


      
  ]
 
  
    return (
        <>

        <Header/>
        <Grid container spacing={2} sx={{m: 1}}>
            <Grid item xs={12} sm={12} md={2.5}>
            <FormControl  sx={{ minWidth: 150 }}>
              <InputLabel id="demo-simple-select-label"
              >Room Number</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={roomNumber}
                onChange={(e)=>{setRoomNumber(e.target.value);getAllTenantsHistory(e.target.value)}}
                label="Room Number"
                sx={{
                  // '& .MuiInputBase-input': {
                  //   height:"2em"
                  // }
                }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {allRooms.map((row,index)=>(
                  <MenuItem value={row.id}>{row.id}</MenuItem>
                ))}
              </Select>
            </FormControl>
            </Grid>
          </Grid>
        <Box
        sx={{
          height: 450,
          width: '100%',
          '& .actions': {
            color: 'text.secondary',
          },
          '& .textPrimary': {
            color: 'text.primary',
          },
        }}
      >
          <DataGrid rows={tenancyDetails} columns={columns}
          getRowId={(row) => row.id}
          />
        </Box>
        {/* <Row style={{marginLeft:"5%"}}>
          <Col><Form.Label><b>Select a Room:</b></Form.Label></Col>
          <Col></Col>
          <Col></Col>
          <Col></Col>
        </Row>
        <Row style={{marginLeft:"5%",marginBottom:"1%"}}>
          <Col><Form.Select className="w-50"  size="sm"
                    value= { roomNumber }  onChange={(e)=>{setRoomNumber(e.target.value);getAllTenantsHistory(e.target.value)}}>
                  <option value=''  >All Rooms</option>
                  {allRooms.map((row,index)=>(
                  <option value={row.id}>{row.id}</option>
                ))}
                </Form.Select></Col>
          <Col></Col>
          <Col></Col>
          <Col style={{fontSize:"1.2rem"}}><b>Number of Records: {tenancyDetails.length}</b></Col>
        </Row> */}
                
                
        
    {isPayment && <MakePayment value={propsForMakePayment}/>}
    {showVoidTenancy && <VoidComponent showVoidTenancy={showVoidTenancy} 
    setShowVoidTenancy={setShowVoidTenancy} currentTenancy={selectedRowData}
    />}

    
  
        </>
        
     

    );
   
   }

export const VoidComponent = ({showVoidTenancy,setShowVoidTenancy,currentTenancy}) =>{
  const [tenancyDescription,setTenancyDescription]=useState("");
  const voidTenancyById = async(tenancyId,roomid) =>{
    try{
      const status="void";
      await axios.patch(`${url}/tenants/${tenancyId}`,{
        status,
        roomid,
        tenancyDescription

      }).then((responseForVoidTenancy)=>{
        console.log(responseForVoidTenancy);
        setShowVoidTenancy(false)

      })
    }
    catch(error){
      console.log(error);
    }
  }
  return <>
  <Modal show={showVoidTenancy} onHide={(e)=>setShowVoidTenancy(false)}
    // show={showCustomerDetails} onHide={handleCloseCustomerDetails}
    >
          <Modal.Body>
            <h4>Are you sure to delete </h4><br></br>
            <div style={{fontSize:"1.1rem"}}>
            <Row className="mb-2">
              <Col>Name(s)</Col>
              <Col> {currentTenancy.names}</Col>
             
            </Row>
            <Row className="mb-2">
              <Col>Phone Number(s)</Col>
              <Col> {currentTenancy.phoneNumbers}</Col>
              
            </Row>
            <Row className="mb-2">
              <Col>Checkin Date</Col>
              <Col> {formatDateText(currentTenancy.checkin)}</Col>
              
            </Row>
            <Row className="mb-2">
              <Col>Expected Checkout</Col>
              <Col> {formatDateText(currentTenancy.checkout)}</Col>
              
            </Row>
            <Row className="mb-2">
              <Col>Actual Checkout</Col>
              <Col> {currentTenancy.actualCheckoutDate ? formatDateText(currentTenancy.actualCheckoutDate) : null }</Col>
              
            </Row>
            <Row><b>Reason For Cancelling :</b></Row>
            <Row className="ms-2 me-2 mt-2">
              <Form.Control as="textarea" value={tenancyDescription} onChange={(e)=>setTenancyDescription(e.target.value)}/>
            </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={(e) => setShowVoidTenancy(false)}
            >
              No
            </Button>
            <Button variant="primary" 
            onClick={(e) => 
            voidTenancyById(currentTenancy.id,currentTenancy.roomid)}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>

  </>

}
